import classNames from "classnames";
import { FC, useEffect, useMemo, useState } from "react";
import LoadingIcon from "../../components/LodingIcon";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import {
  ManifestIncidence,
  ManifestStatus,
  ManifestType,
} from "../../interfaces/ManifestInterface";
import { InventoryHeaderInterface } from "../../interfaces/InventoryInterface";
import {
  createPendingDetails,
  removeAllProcessedDetails,
  setInventoryForm,
  setInventoryHeader,
  setInventoryLoadFromDB,
} from "../../store/slices/inventory";
import { alertService, loaderService } from "../../services";
import {
  createObjectManifestDetailSingle,
  getManifestDetails,
} from "../../services/manifestServices";
import InventoryHeaderTable from "./InventoryHeaderTable";
import { createObjectInventoryDetailSingle, getInventoryDetails } from "../../services/inventoryServices";

interface InventoryDraftTableProps {
  loadingInventory: boolean;
  postponedInventoryList: InventoryHeaderInterface[];
}
const InventoryDraftTable: FC<InventoryDraftTableProps> = ({ loadingInventory, postponedInventoryList }) => {
  const inventory = useAppDispatch();
  const navigate = useNavigate();
  
  const handleClickPostponedManifest = async (
    manifest: InventoryHeaderInterface
  ) => {
    loaderService.start();
    const InventoryHeaderID = manifest.inventoryHeaderID;

    if (!InventoryHeaderID) {
      alertService.error("El inventario parece no estar registrado.");
      loaderService.stop();
      return;
    }

    const details = await getInventoryDetails(InventoryHeaderID);

    if (details.didError || details.model === null) {
      alertService.error(
        "Hubo un error obteniendo los detalles del inventario."
      );
      loaderService.stop();
      return;
    }

    const filteredDetails = details.model.filter(
      (d) => d.statusID !== ManifestStatus.ELIMINADO
    );

    const inventoryDetails = createObjectInventoryDetailSingle(
      filteredDetails.map((d) => ({
        ...d,
        incidence: ManifestIncidence.NOT_VALIDATED,
        errors: "",
        warnings: "",
        incidenceWarning: false,
      })),
      ManifestType.DESPACHO
    );


    inventory(setInventoryLoadFromDB(true));
    inventory(createPendingDetails(inventoryDetails));
    inventory(removeAllProcessedDetails());
    inventory(
      setInventoryHeader({
        ...manifest,
        observation:
          manifest.observation ?? "",
      })
    );
    inventory(
      setInventoryForm({
        observation: manifest.observation ?? "",
      })
    );

    loaderService.stop();
    navigate("/inventory/create");
  };

  const loadingData = useMemo(() => {
    return loadingInventory ;
  }, [loadingInventory]);
 

  return (
    <div
      className={classNames(
        "flex flex-1 flex-col bg-white gap-4 rounded-lg border px-6 py-6 w-full"
      )}
    >
      <h1 className="text-2xl font-semibold text-gray-800 truncate mb-2">
        Inventario Abierto
      </h1>
      <div
        className={classNames(
          "flex flex-1 flex-row bg-white gap-4 rounded-lg justify-center items-center"
        )}
      >
        {loadingData && (
          <div className="my-12">
            <LoadingIcon size="3.5rem" />
          </div>
        )}

        {!loadingData && (
          <InventoryHeaderTable
            inventorys={postponedInventoryList}
            onInventoryClick={handleClickPostponedManifest}
          />
        )}
      </div>
    </div>
  );
};

export default InventoryDraftTable;
